import {
  Button, Checkbox,
  Modal,
  ModalBody,
  ModalHeader,
  ModalProps,
  Stack,
  Textarea,
  TextInput
} from "@mantine/core";
import {useForm} from "@mantine/form";
import {DatePickerInput} from "@mantine/dates";
import PlannedFailureAPI from "../../../api/planned/failure/PlannedFailureAPI";
import {showNotification} from "@mantine/notifications";

const format = (dateString: string) => {
    if (dateString === null || dateString === undefined || dateString === "") {
        return undefined;
    }

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based month
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
}

type CreatePlannedFailureModalProps = Omit<ModalProps, "children">;

export default function CreatePlannedFailureModal(props: CreatePlannedFailureModalProps) {
    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
          location: '',
          date: new Date(),
          description: '',
          isDone: false,
        }
    });

    const onSubmit = (data: any) => {
        PlannedFailureAPI.create({...data, date: format(data.date)})
            .then(() => { showNotification({ title: 'Utworzono!', message: "Awaria została utworzona" }) })
            .then(props.onClose);
    }

    return (
        <Modal {...props}>
            <ModalHeader>
                Nowa planowana awaria
            </ModalHeader>

            <ModalBody>
                <form onSubmit={form.onSubmit(onSubmit)}>
                    <Stack gap="sm" style={{ width: '100%' }}>
                        <DatePickerInput
                            required
                            label="Data"
                            valueFormat="DD-MM-YYYY"
                            key={form.key('date')}
                            { ...form.getInputProps('date') }
                        />

                        <TextInput
                            required
                            label="Miejsce"
                            placeholder="Miejsce"
                            key={form.key('location')}
                            { ...form.getInputProps('location') }
                        />

                        <Textarea
                            required
                            label="Opis"
                            rows={10}
                            placeholder="Opis"
                            key={form.key('description')}
                            description="Inne informacje np. metoda zabezpieczenia"
                            { ...form.getInputProps('description') }
                        />

                      <Checkbox
                        label="Czy awaria została zakończona?"
                        key={form.key('isDone')}
                        { ...form.getInputProps('isDone') }
                      />

                        <Button
                            fullWidth
                            type="submit"
                            children="Zapisz"
                        />
                    </Stack>
                </form>
            </ModalBody>
        </Modal>
    );
}